import IComponent from "components/commons/IComponent";
import "./LayerSetting.scoped.css";
import MiniPanel from "components/commons/MiniPanel";
import EditableDatagridCell from "components/commons/EditableDatagridCell";
import Button from "@material-ui/core/Button";
import LayerToggleUtil from "utils/LayerToggleUtil";
import SwitchButton from "components/commons/SwitchButton";
import OpacitySlider from "./OpacitySlider";
import geometryTools from "utils/geometryTools";

const LAYER_TYPE_OPACITY_SUPPORT = {
  "building-scene": 1,
  // "point-cloud": 1,
  scene: 1,
  feature: 1,
  bim: 1,
};

let queryTimer = null;
class Manage3DLayer extends IComponent {
  constructor(props) {
    super(props);
    this.state = {
      filterKeyword: "",
      searchByExtent: false,
      extentfilter: null,
    };
  }
  componentDidMount() {
    this.removeHandler = this.props.mapView.watch(
      "stationary",
      (newV, oldV) => {
        if (newV && this.state.searchByExtent) {
          clearTimeout(queryTimer);
          queryTimer = setTimeout(
            (() => {
              this.setState({ extentfilter: this.props.mapView.extent });
            }).bind(this),
            500
          );
        }
      }
    );
  }

  componentWillUnmount() {
    this.removeHandler.remove();
  }

  isAnyLayerAdded(category, tag) {
    let layerList = this.$config[`mapList${this.props.isSecondMap ? "2" : ""}`];
    return layerList.layer3D[category].some((i) =>
      tag ? i.tags.some((t) => t == tag) && !!i.layer : !!i.layer
    );
  }

  prepareMultiLvList(layerList, filterText, filterExtent) {
    let availList = this.$config.AvailLayerList;
    let objectList = [];
    let resultList = { objectList };
    Object.keys(layerList.layer3D).forEach((category) => {
      resultList[category] = {};
      var categoryItem = layerList.layer3D[category];
      var availListItem = availList.layer3D[category];
      categoryItem.forEach((layer, idx) => {
        // This line is to filter the layer list by current extent
        // Will be useful in the new 3D Layer Maanger
        if (
          !layer.extent ||
          (filterExtent && !filterExtent.intersects(availListItem[idx].extent))
        )
          return;

        if (!!filterText) {
          if (
            !(
              layer.tags.some(
                (i) => i.toLowerCase().indexOf(filterText) > -1
              ) || layer.title.toLowerCase().indexOf(filterText) > -1
            )
          )
            return;
        }
        let subLvDetail = layer.tags.filter((i) => i.indexOf(":") > -1).sort();
        let objectIdx = objectList.push(layer) - 1;
        let lastNode = resultList[category];
        if (subLvDetail.length > 0) {
          lastNode = resultList[category];
          subLvDetail.forEach((lv) => {
            if (!(lv in lastNode)) lastNode[lv] = {};
            lastNode = lastNode[lv];
          });
        }
        lastNode["OBJECT-" + objectIdx] = objectIdx;
      });
    });
    // for (var key in resultList) {
    //   if (Array.isArray(resultList[key]) && !resultList[key].length)
    //     delete resultList[key];
    // }
    console.debug(resultList);
    return resultList;
  }

  createLayerTitleSection(c, category) {
    let isCategory = typeof c === "string";
    let isenabled = isCategory ? this.isAnyLayerAdded(category, c) : c.enabled;
    let title = isCategory ? c : c.title;
    title = title.substr(title.indexOf(":") + 1);
    let vm = this;
    if (isCategory) {
      return (
        <div style={isCategory ? {} : { margin: "5px" }}>
          <span
            className={`addLyrBtn icn_3d_maintain_${
              isenabled ? "remove" : "add"
            } ${isenabled ? "removeBtnColor" : ""}`}
            onClick={() => {
              if (isCategory) {
                this.props.showDialog({});
                let isAnyTurnedOn = this.isAnyLayerAdded(category, c);
                LayerToggleUtil.toggle3DLayerByTag(
                  category,
                  c,
                  !isAnyTurnedOn,
                  this.props.mapView,
                  this.props.isSecondMap,
                  true
                );
              }

              this.setState({});
              let tmp = this.props.mapView.map.findLayerById("LDS-Sensors");
              tmp && (tmp.definitionExpression = "1=2");
            }}
          />
          {title}
        </div>
      );
    } else {
      return (
        <div className="ListItemBottomLine SubPanelContent">
          <SwitchButton
            label={<span>{c.title}</span>}
            placeAtRight={true}
            checked={!!isenabled}
            onClick={() => {
              this.props.showDialog({});
              LayerToggleUtil.toggle3DLayer(
                category,
                c,
                undefined,
                this.props.mapView,
                this.props.isSecondMap,
                true
              );
              this.setState({});
              let tmp = this.props.mapView.map.findLayerById("LDS-Sensors");
              tmp && (tmp.definitionExpression = "1=2");
            }}
            needMidICON={!!isenabled}
            midICONClassName={"icn_zoomtolayer"}
            disableLabelClick={true}
            midICONOnClick={async () => {
              console.log("zoom to layer by mid icon", c);
              if (c && c.layer.fullExtent && c.type !== "voxel") {
                let newCam = vm.props.mapView.camera.clone();
                newCam.tilt = 45;
                await this.props.mapView.goTo(newCam);
                await this.props.mapView.goTo(c.layer.fullExtent, {
                  animate: false,
                });
              } else if (c && c.layer.fullExtent && c.type === "voxel") {
                let activeExtent = c.layer.fullExtent;
                activeExtent.spatialReference = new geometryTools.SpatialReference(
                  {
                    wkid: 102140,
                    latestWkid: 2326,
                  }
                );
                activeExtent.zmin = -30;
                let extentBuffer = 1000;
                Object.keys(activeExtent).forEach((key) => {
                  if (["xmax", "ymax"].includes(key)) {
                    activeExtent[key] += extentBuffer;
                  }
                  if (["xmin", "ymin"].includes(key)) {
                    activeExtent[key] -= extentBuffer;
                  }
                });
                console.log("activeExtent", activeExtent);
                vm.props.mapView.goTo(activeExtent).catch((err) => {
                  console.warn(err);
                });
              }
            }}
          />
          {isenabled && c.layer.type in LAYER_TYPE_OPACITY_SUPPORT && (
            <OpacitySlider layer={c.layer} />
          )}
        </div>
      );
    }
  }

  createLayerComponents(list, title, linkedList, category, filterText) {
    if (!list) return undefined;
    return (
      <div
        key={`SubItem-${title}`}
        className="EqualWidthChildren column SubPanelContent ListItemBottomLine"
      >
        {Object.keys(list).map((c, i) => {
          let item = list[c];
          if (typeof item !== "number") {
            return (
              <MiniPanel
                titleClass="ListItemBottomLine"
                titleText={this.createLayerTitleSection(c, category)}
                defaultCollapsed={!filterText}
              >
                {this.createLayerComponents(
                  item,
                  c,
                  linkedList,
                  category,
                  filterText
                )}
              </MiniPanel>
            );
          } else {
            return (
              <div>
                {this.createLayerTitleSection(linkedList[item], category)}
              </div>
            );
          }
        })}
      </div>
    );
  }

  render() {
    let vm = this;
    let filter = this.state.filterKeyword;
    let layerList = this.$config[`mapList${this.props.isSecondMap ? "2" : ""}`];
    let { searchByExtent, extentfilter } = this.state;
    let levelLv = this.prepareMultiLvList(
      layerList,
      filter,
      searchByExtent && extentfilter
    );

    return (
      <div className="Manage3DLayerContainer">
        <div className="PanelTitle">
          <div className="EqualWidthChildren">
            <div className="Maintain3DTitle">
              Maintain
              <br />
              3D Layer List
            </div>
            <div
              className="icn_3d_Elevationprofile_close CloseBtn IconColor2"
              onClick={() => {
                vm.props.onClose3DManagerCallback();
              }}
            />
          </div>
        </div>
        <div className="SubPanelContent">
          <SwitchButton
            label="Show related 3D data"
            checked={searchByExtent}
            onClick={() => {
              this.setState(
                {
                  searchByExtent: !searchByExtent,
                  extentfilter: this.props.mapView.extent,
                },
                () => {}
              );
            }}
          />
          <div className="EqualWidthChildren">
            <EditableDatagridCell
              cellInfo={{
                colDef: {
                  field: "filterKeyword",
                  dataType: "text",
                  hint: "Enter Keyword",
                },
                row: this.state,
              }}
              onChange={(a, v) =>
                this.setState({ filterKeyword: v.toLowerCase() })
              }
            />
            <Button
              classes={{ root: "actionBtn" }}
              variant="contained"
              onClick={() => {}}
              style={{ height: "58.5px" }}
            >
              <span className="icn_menu_search icon_s" onClick={() => {}} />
            </Button>
          </div>
        </div>
        <div
          style={{
            height: "100%",
            overflow: "auto",
          }}
        >
          {Object.keys(layerList.layer3D).map((i, j) => (
            <div className="EqualWidthChildren LayerCategory" key={j}>
              <span
                className={`addLyrBtn icn_3d_maintain_${
                  this.isAnyLayerAdded(i) ? "remove" : "add "
                } ${this.isAnyLayerAdded(i) ? "removeBtnColor" : ""} `}
                onClick={() => {
                  this.props.showDialog({});
                  var toggleValue = !this.isAnyLayerAdded(i);
                  var layers = layerList.layer3D[i];
                  if (filter != "")
                    layers = layers.filter(
                      (c) => c.title.toLowerCase().indexOf(filter) > -1
                    );
                  layers.forEach((l1, l2) =>
                    LayerToggleUtil.toggle3DLayer(
                      i,
                      l1,
                      toggleValue,
                      this.props.mapView,
                      this.props.isSecondMap,
                      true
                    )
                  );
                  // remove LDS sensors
                  let tmp = this.props.mapView.map.findLayerById("LDS-Sensors");
                  tmp && (tmp.definitionExpression = "1=2");
                  this.setState({});
                }}
              />
              <div>
                <MiniPanel
                  titleClass="fontbold SubPanelContent ListItemBottomLine"
                  titleText={i}
                >
                  {this.createLayerComponents(
                    levelLv[i],
                    i,
                    levelLv.objectList,
                    i,
                    filter
                  )}
                </MiniPanel>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default Manage3DLayer;
